export function removeHTML(html: string): string {
  return html.replace(/<[^>]*>?/gm, "");
}
